import * as type from '../../types';


const initialForgotPassword = {
    response : {},
    loading:false,
    error:null
}


export const forgotPasswordReducer = (state = initialForgotPassword, action)=>{

    switch(action.type){
        case type.CHANGE_PASSWORD_REQUEST:
           return {
             ...state,
             loading: true
           };  
           case type.FORGOT_PASSWORD_SUCCESS:
            return{
                ...state,
                loading: false,
                response: action.data
            }
            case type.FORGOT_PASSWORD_FAILURE:
                return{
                 ...state,
                 loading: false,
                  response: action.message
                }
            default:
                return state;    
    }

}
